import { Component, OnInit } from "@angular/core";
import { NgForm } from "@angular/forms";
import { Router } from "@angular/router";
import { MLSListingService } from "src/services/mls-listings.service";
import locations from "../../../data/locations";

@Component({
    selector: "app-home-page",
    templateUrl: "./home-page.component.html",
    styleUrls: ["./home-page.component.css"],
})
export class HomePageComponent implements OnInit {
    locations = locations;
    formattedAddress = "";

    options = {
        componentRestrictions: {
            country: ["US"],
        },
    };

    constructor(
        private router: Router,
        private mlsService: MLSListingService
    ) {}

    ngOnInit(): void {}

    openLocation(state) {
        this.router.navigate(["/location/" + state]);
    }

    public handleAddressChange(address: any) {
        // console.log(address);
        // this.mlsService.getSearchResults(address);
        this.mlsService.getSearchResults(address).subscribe((res) => {
            this.mlsService.setSearchResults(res);
        });
    }

    submitForm(form: NgForm) {
        if (form.invalid) {
            return;
        }
        this.mlsService
            .advancedSearch(
                form.value.area,
                form.value.beds,
                form.value.baths,
                form.value.minPrice,
                form.value.maxPrice
            )
            .subscribe((res) => {
                this.mlsService.setSearchResults(res);
            });

        // console.log(form.value.area);
        // console.log(form.value.beds);
        // console.log(form.value.baths);
        // console.log(form.value.minPrice);
        // console.log(form.value.maxPrice);
    }
}
